var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.643 26.524l-7.635-7.547-7.636 7.547M23.008 18.977v16.98",
    stroke: "#CCC",
    strokeWidth: 2.369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.023 31.033c3.83-2.064 5.757-6.431 4.681-10.61-1.076-4.178-4.88-7.104-9.243-7.107h-2.405c-1.582-6.049-6.772-10.51-13.052-11.218-6.281-.709-12.354 2.48-15.275 8.021a14.957 14.957 0 002.1 16.97",
    stroke: "#CCC",
    strokeWidth: 2.369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.643 26.524l-7.635-7.547-7.636 7.547",
    stroke: "#CCC",
    strokeWidth: 2.369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUploadCloud;